module.exports = __webpack_public_path__ + "img/pdf.d7157e8b.svg";